import UserSettings from '../components/minskog/comps/UserSettings';
import { TailwindWrapper } from '@utils/TailwindWrapper';

export default function UserSettingsPage() {

  return (
    <TailwindWrapper>
      <div className="w-full p-0">
        <div className="min-h-screen flex flex-col">
          <main className="flex-1 min-h-0 overflow-hidden flex flex-col">
            <UserSettings />
          </main>
        </div>
      </div>
    </TailwindWrapper>
  );
}
